// extracted by mini-css-extract-plugin
export default {"cart-modal":"cart_cart-modal__zgj7W","show-cart":"cart_show-cart__YhifL","cart-items":"cart_cart-items__EzdoY","delete-button":"cart_delete-button__IUcSE"};